import * as React from 'react';

import { DateInput } from 'src/components';
import { defaultFilters } from '../services/defaultFilters';
import { IFiltersProps, IFiltersState } from '../types';
import { primaryFactory } from 'src/services/themeColors';

const ParagraphPrimary = primaryFactory('p');

class Filters extends React.Component<IFiltersProps, IFiltersState> {
  today = defaultFilters.dateTo;
  state: IFiltersState = {
    isFiltering: false,
    ...defaultFilters,
  };

  onDateChange = (field: string, date: Date) => {
    this.setState((state) => {
      state[field] = date;
      return { ...state };
    }, this.filter);
  };

  filter = async () => {
    const { isFiltering, ...filters } = this.state;
    this.setState({ isFiltering: true });
    await this.props.onSubmit(filters);
    this.setState({ isFiltering: false });
  };

  render() {
    const { dateFrom, dateTo } = this.state;
    return (
      <div className="mr-4 mb-16 w-64">
        <ParagraphPrimary className="mb-4">Created on</ParagraphPrimary>
        <div className="my-2 flex items-center">
          <span className="inline-block w-12">From</span>
          <DateInput
            selected={dateFrom}
            onChange={this.onDateChange.bind(null, 'dateFrom')}
            maxDate={dateTo}
            secondary={true}
            small={true}
            className="flex-1 py-2"
          />
        </div>
        <div className="my-2 flex items-center">
          <span className="inline-block w-12">To</span>
          <DateInput
            selected={dateTo}
            onChange={this.onDateChange.bind(null, 'dateTo')}
            minDate={dateFrom}
            maxDate={this.today}
            secondary={true}
            small={true}
            className="flex-1 py-2"
          />
        </div>
      </div>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/views/TargetCheck/components/Filters.tsx